export const INDIA_STATES = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa",
  "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala",
  "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland",
  "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura",
  "Uttar Pradesh", "Uttarakhand", "West Bengal",
  "Andaman and Nicobar Islands", "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu", "Delhi", "Jammu and Kashmir",
  "Ladakh", "Lakshadweep", "Puducherry",
];

const STATE_ALIASES = {
  "nct of delhi": "Delhi", "delhi": "Delhi", "orissa": "Odisha", "uttaranchal": "Uttarakhand", "pondicherry": "Puducherry",
  "jammu and kashmir": "Jammu and Kashmir", "andaman and nicobar": "Andaman and Nicobar Islands",
  "dadra and nagar haveli": "Dadra and Nagar Haveli and Daman and Diu", "daman and diu": "Dadra and Nagar Haveli and Daman and Diu",
};
const normState = (n) => (n || "").toLowerCase().replace(/&/g, "and").replace(/\s+/g, " ").trim();
/** Maps a state name from any source (e.g. India Post) to one of INDIA_STATES, or "" when unknown. */
export const matchState = (name) => {
  const n = normState(name);
  return INDIA_STATES.find((s) => normState(s) === n) || STATE_ALIASES[n] || "";
};

export const validators = {
  name: (v) => {
    if (!v || !v.trim()) return "Name is required";
    if (v.trim().length < 2) return "Name must be at least 2 characters";
    if (!/^[a-zA-Z][a-zA-Z\s.'-]*$/.test(v.trim())) return "Enter a valid name";
    return "";
  },
  email: (v) => {
    if (!v || !v.trim()) return "Email is required";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim())) return "Enter a valid email address";
    return "";
  },
  mobile: (v) => {
    if (!v || !v.trim()) return "Mobile number is required";
    if (!/^[6-9]\d{9}$/.test(v.trim())) return "Enter a valid 10-digit Indian mobile number";
    return "";
  },
  pincode: (v) => {
    if (!v || !v.trim()) return "Pincode is required";
    if (!/^[1-9]\d{5}$/.test(v.trim())) return "Enter a valid 6-digit pincode";
    return "";
  },
  required: (v, label = "This field") => (!v || !String(v).trim() ? `${label} is required` : ""),
};
